<template>
  <shared-provide-variation :variation="variation" :fromModule="fromModule" :toModule="toModule" @change="emitToParent">
    <loader :loading="loading"></loader>
    <div class="l-row">
      <form-group v-if="Object.keys(variation.attributes).indexOf('color') !== -1 && colors.length" :label="$t(`color.label`)" :columns="3" :error="getError('attributes.color', variation.sku)" :required="true">
        <multiselect v-model="variation.attributes.color" :options="colors" selectLabel="Clique" selectedLabel="Selecionado" placeholder="Selecione a opção" :disabled="disabledInputs()">
        </multiselect>
      </form-group>

      <form-group v-if="Object.keys(variation.attributes).indexOf('size') !== -1" :label="$t(`size.label`)" :columns="3" :error="getError('attributes.size', variation.sku)" :required="sizes.length > 0">
        <select v-model="variation.attributes.size" class="form-select" :disabled="disabledInputs()" v-if="sizes.length">
          <option value="null">{{ $t('choose.label') }}</option>
          <option v-for="size in sizes" :value="size">{{ size }}</option>
        </select>
        <input class="form-input" type="text" v-model="variation.attributes.size" :disabled="disabledInputs()" v-else>
      </form-group>

      <form-group v-if="Object.keys(variation.attributes).indexOf('voltage') !== -1" :label="$t(`voltage.label`)" :columns="3" :error="getError('attributes.voltage', variation.sku)" :required="true">
        <input class="form-input" type="text" v-model="variation.attributes['voltage']" :disabled="disabledInputs()">
      </form-group>
    </div>

    <div class="l-col-12@md" v-if="variation.gfgAttributes !== undefined && variation.gfgAttributes.length">
      <div class="divider"><span>Atributos</span></div>
    </div>
    <div class="l-row" v-if="variation.gfgAttributes !== undefined && variation.gfgAttributes.length">
      <form-group v-for="(attribute, index) in variation.gfgAttributes" :key="attribute.code" :label="attribute.label" :columns="3" :error="getError(attribute.code, variation.sku)" :required="attribute.required" v-if="variation.gfgAttributes !== undefined && variation.gfgAttributes.length">
        <select v-model="attribute.value" class="form-select" :disabled="disabledInputs()" v-if="attribute.typeSelection === 'select'">
          <option value="undefined">{{ $t('choose.label') }}</option>
          <option v-for="option in attribute.values" :value="option">{{ option }}</option>
        </select>
        <multiselect v-model="attribute.value" :options="attribute.values" :multiple="true" v-else-if="attribute.typeSelection === 'multiselect'" selectLabel="Clique" selectedLabel="Selecionado" placeholder="Selecione a opção">
        </multiselect>
        <input class="form-input" type="text" v-model="attribute.value" :disabled="disabledInputs()" v-else>
      </form-group>
    </div>
  </shared-provide-variation>
</template>

<script>
  import SharedProvideVariation from '@/components/marketplace/shared/provide/Variation'
  import FormGroup from '@/components/template/FormGroup'
  import Loader from '@/components/template/Loader'
  import { mapGetters } from 'vuex'

  export default {
    data: () => ({
      loading: false,
      colors: [],
      sizes: [],
      variationColor: null,
      variationSize: null
    }),
    props: {
      variation: {
        type: Object,
        required: true
      },
      fromModule: {
        type: Object,
        required: true
      },
      toModule: {
        type: Object,
        required: true
      }
    },
    async mounted () {
      const presetColor = this.$parent.$parent.$parent.getPresetItemByTypeAndFrom('color', { color: this.variation.attributes.color })
      if (presetColor !== null && presetColor !== undefined) {
        this.variation.attributes.color = presetColor.color
      }

      this.variationColor = this.variation.attributes.color

      this.variationSize = this.variation.attributes.size
    },
    methods: {
      disabledInputs () {
        return this.variation.status === 'sent' || this.variation.status === 'error'
      },
      emitToParent (value) {
        this.$emit('change', value)
      },
      setColorOptions (attributes) {
        this.colors = []
        const colorAttribute = attributes.find(attribute => attribute.code === 'ColorFamily')
        if (colorAttribute !== undefined) {
          this.colors = colorAttribute.values

          this.variation.attributes.color = this.colors.find(color => this.variationColor && color.toLowerCase() === this.variationColor.toLowerCase()) || null

          this.variation.gfgAttributes = attributes.filter(attribute => attribute.code !== 'ColorFamily')
        }
      },
      setSizeOptions (attributes) {
        this.sizes = []

        const sizeAttribute = attributes.find(attribute => attribute.code === 'Variation')
        if (sizeAttribute !== undefined) {
          if (sizeAttribute.typeSelection !== 'select') {
            this.variation.gfgAttributes = attributes.filter(attribute => attribute.code !== 'Variation')
            return
          }

          this.sizes = sizeAttribute.values

          this.variation.attributes.size = this.sizes.find(size => this.variationSize && size.toString().toLowerCase() === this.variationSize.toString().toLowerCase()) || null

          this.variation.gfgAttributes = attributes.filter(attribute => attribute.code !== 'Variation')
        } else {
          delete this.variation.attributes['size']
        }
      }
    },
    computed: {
      ...mapGetters('errors', [
        'getError'
      ])
    },
    watch: {
      'variation.category' () {
        if (this.loading === true) {
          return false
        }

        this.loading = true

        this.setColorOptions(this.variation.gfgAttributes)
        this.setSizeOptions(this.variation.gfgAttributes)

        this.loading = false
      }
    },
    components: {
      Loader,
      SharedProvideVariation,
      FormGroup
    }
  }
</script>



// WEBPACK FOOTER //
// Variation.vue?bb3a91c2